import React, { ReactNode } from 'react';
import styled from 'styled-components';

interface Props {
  children: ReactNode;
}

const BoxWrapper = styled.div`
  background-color: var(--surface);
  border: 1px solid var(--surface-border);
  padding: 0.5rem 1rem;
  /* transition: var(--standard-transition); */
`;

export const Box = ({ children }: Props) => {
  return <BoxWrapper>{children}</BoxWrapper>;
};
